import { z } from 'zod';
const formSchema = z.object({
  alv_id: z.number(),
  send_notifications: z.boolean(),
  voicemail_email_addresses: z.array(z.object({ email: z.string().email() })),
});

export { formSchema };
